import { query, } from "@lookiero/messaging";
import { viewTranslationKeyByLocale } from "./viewTranslationKeyByLocale";
const VIEW_TRANSLATION_BY_LOCALE = "view_translation_by_locale";
const viewTranslationByLocale = (payload) => ({
    ...query({ name: VIEW_TRANSLATION_BY_LOCALE }),
    ...payload,
});
const viewTranslationByLocaleHandler = ({ view, queryBus }) => async ({ locale }) => view({
    translationKey: await queryBus(viewTranslationKeyByLocale({ locale })),
});
export { VIEW_TRANSLATION_BY_LOCALE, viewTranslationByLocale, viewTranslationByLocaleHandler, };
